import { mapState } from 'vuex'

export default {
  name: 'qr-code',
  data () {
    return {
      timer: null,
      value: false,
      title: '长按识别二维码关注服务号后继续浏览',
      qrcodeSrc: '',
      qrcodeTime: 30 * 1000,
      checkoutTimer: null,
      showQr: true
    }
  },
  computed: {
    ...mapState(['wechatUser', 'serviceConfig'])
  },
  destroyed () {
    clearTimeout(this.timer)
    clearTimeout(this.qrTimer)
  },
  mounted () {
    if (!this.serviceConfig.mustSubscribe) return
    if(+this.wechatUser.subscribe === 1) return
    this.init()
  },
  methods: {
    init () {
      this.qrcodeSrc = this.serviceConfig.qrcodeSrc
      this.qrcodeTime = parseInt((+this.serviceConfig.qrcodeTime) * 1000)
      this.delay(this.qrcodeTime)
    },
    delay(newVal) {
      if (!newVal) return
      this.timer = setTimeout(() => {
        if (+this.wechatUser.subscribe !== 1) {
          this.blockMedia()
          this.value = true
        }
      }, newVal)
    },
    /**
     * 暂停媒体播放
     */
    blockMedia () {
      window.mediaQueue.forEach(media => {
        if (typeof media.remove === 'function') {
          return media.remove() // 关闭视频
        }
        media.pause()
      })
    }
  }
}
